<template>
    <div
            class="landing-page-header-hoh"
    >
        <div
                class="logo height d-md-flex align-items-center justify-content-center"
                v-if="!isHubPreviewPage && companyLogo"
        >
            <b-img
                    class="lp-header-hoh-company-logo"
                    :src="companyLogo"
            />
        </div>
        <div
                v-if="isHubPreviewPage"
                class="hoh-address-name height d-flex align-items-center justify-content-center"
        >
            <i
                    class="fas fa-arrow-left cursor-pointer"
                    @click="handleBackClick"
            />
            <h1
                    v-if="headerAddress"
                    class="hoh-address mb-0"
            >
                {{ headerAddress }}
            </h1>
        </div>
        <div class="right-corner">
            <div class="height d-md-flex align-items-center justify-content-lg-center pl-3 pl-lg-0">
                <div class="get-started height d-flex align-items-center justify-content-center">
                    <template v-if="isHubPreviewPage">
                        <b-button
                                size="lg"
                                variant="primary"
                                block
                                class="btn-action w-100"
                                @click="handleActionBtnClick"
                        >
                            Claim My Home
                        </b-button>
                    </template>
                    <template v-else>
                        <b-link
                                class="text-decoration-none"
                                @click="handleActionBtnClick"
                        >
                            <h4 class="text">
                                {{ actionBtnText }}
                                <i class="fas fa-arrow-right" />
                            </h4>
                        </b-link>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import './LandingPageHeaderHOH.scss';
    import './LandingPageHeaderHOH.mobile.scss';
    import LandingPageAppResource from '@milestoneslabs/milestones-core-js/src/AppResources/LandingPageAppResource';
    import get from "lodash/get";
    import QueryStrings from "@milestoneslabs/milestones-unified-login/src/QueryStrings";
    import {mapState} from "vuex";

    export default {
        name: "LandingPageHeaderHOH",

        props: {
            btnActionCallback: {
                type: Function,
                default: () => {
                },
            },
            landingPage: {
                type: LandingPageAppResource,
                required: true,
            },
        },
        data() {
            return {
                address: '',
            };
        },
        computed: {
            ...mapState({
                authUser: state => state.landingPage.authUser
            }),
            actionBtnText() {
                if (this.isHubPreviewPage && this.authUser?.uuid) {
                    return 'Claim My Home';
                }
                if (!this.authUser.uuid) {
                    return 'Sign In';
                }
                return '';
            },
            companyLogo() {
                return (this.landingPage.organizationLogo || {}).publicStorageUrl || null;
            },
            isHubPreviewPage() {
                return this.$route.name === 'landing-page.hub-preview';
            },
            headerAddress() {
                if (!this.address) {
                    return;
                }

                if (this.address.deliveryLine) {
                    return this.address.deliveryLine;
                }

                let address = this.address.streetNumber ? this.address.streetNumber + ' ' : '';
                address += this.address.street ? this.address.street : '';

                if (!address && this.address.fullAddress) {
                    address = this.address.fullAddress;
                }

                return address;
            }
        },
        methods: {
            setAddress() {
                let hohAddress = get(this.$route.query, QueryStrings.HOH_ADDRESS, null);

                if (!hohAddress) {
                    return;
                }

                let address;
                try {
                    address = JSON.parse(atob(hohAddress));
                } catch (e) {
                    console.warn(e);
                }

                if (typeof address !== 'object') {
                    return;
                }
                this.address = address;
            },
            handleBackClick() {
                this.$router.push({name: 'landing-page.home'});
            },
            handleActionBtnClick() {
                this.btnActionCallback();
            }
        },
        mounted() {
            if (this.isHubPreviewPage) {
                this.setAddress();
            }
        },
        watch: {
            isHubPreviewPage(newVal) {
                if (newVal) {
                    this.setAddress();
                }
            }
        }
    };
</script>
